<div class="home-search modal">
  <div class="modal">
    <div class="modal__top">
      <span class="modal__title"> {{ 'COMMONS.SEARCH' | i18nextEager | uppercase }}</span>
      <span class="modal__click" (click)="closeDialog()">
        <img src="/assets/icons/close_modal.svg" alt="" />
      </span>
    </div>
    <div class="modal__body">
      <form [formGroup]="searchForm">
        <div class="modal__input modal__input__inline select">
          <app-custom-select
            class="width100"
            [controlName]="'types'"
            [values]="data.typesData"
            [defaultValue]="data.typeDefault"
          ></app-custom-select>
        </div>
        <div>
          <mat-form-field appearance="outline">
            <input
              matInput
              formControlName="search"
              [placeholder]="('HOME.SEARCH.MIN_CHARS' | i18nextEager: { length: 3 }) + ' ...'"
              minlength="3"
              maxlength="100"
            />
            <button type="submit" (click)="search()" class="suffix-icon" *ngIf="data.reseted === true; else elseBlock">
              <img src="/assets/icons/search.svg" alt="" />
            </button>
            <ng-template #elseBlock>
              <button type="reset" (click)="reset()" class="suffix-icon">
                <img src="/assets/icons/close.svg" alt="" />
              </button>
            </ng-template>
            <mat-error *ngIf="searchForm.controls['search'].hasError('minlength')">
              {{ 'HOME.SEARCH.MIN_CHARS' | i18nextEager: { length: 3 } }}
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <div class="results" *ngIf="data.results">
        <div>{{ data.results.totalCount }} {{ 'HOME.SEARCH.RESULTS' | i18nextEager }}</div>
        <div class="results__data" *ngIf="data.results.values.length">
          <div
            [ngClass]="{ results__data__item: true, columns2: twoColumnsClass }"
            *ngFor="let item of data.results.values.slice(0, data.showItems)"
          >
            <div *ngIf="item.cifRazonSocial">{{ item.cifRazonSocial }}</div>
            <div>{{ item.nombre }}</div>
            <div class="icon-link" (click)="handleSelect(item)"><img src="assets/icons/arrow-right.svg" alt="" /></div>
          </div>
        </div>
        <div *ngIf="data.showItems < data.results.values.length" class="more_results">
          <span (click)="showMoreResults()">{{ 'HOME.SEARCH.MORE_RESULTS' | i18nextEager }}</span>
        </div>
      </div>
    </div>
    <div class="modal__footer"></div>
  </div>
</div>
